import { Appointment } from "@elixir/types";
import { ReactComponent as TextRegularIcon } from "../../../../assets/icons/font-awesome/text-regular.svg";
import { onCreateTemplateAction } from "../../../../utils/bridges/methods";
import { ChipWithTooltip } from "ui";

const CreateATemplate = ({
  apt,
  className = "",
  type,
}: {
  apt: Appointment;
  className?: string;
  type?: "primary" | "secondary";
}) => {
  return (
    <ChipWithTooltip
      onClick={() => {
        onCreateTemplateAction(apt);
      }}
      className={`h-32 flex-1 ${className}`}
      icon={<TextRegularIcon className="dr-min-w-14 dr-h-14" />}
      title="Medical Records"
      tooltipText="Request Medical Records"
      type={type}
    />
  );
};

export default CreateATemplate;
